module.exports = __webpack_public_path__ + "img/source_book-item15.9a4840cb.png";